import React from 'react';
import { Star, ShieldCheck } from 'lucide-react';
const testimonials = [{
  initials: 'LM',
  name: 'Laura M.',
  city: 'Buenos Aires 🇦🇷',
  text: 'Compré un sábado. El domingo a la noche tenía el trimestre completo organizado. Nunca más improviso.'
}, {
  initials: 'GS',
  name: 'Gabriela S.',
  city: 'Córdoba 🇦🇷',
  text: 'Tres alumnos de Nivel Inicial que no lograban el freno motor mejoraron en el primer mes con el Tomo 1.'
}, {
  initials: 'RF',
  name: 'Rocío F.',
  city: 'Rosario 🇦🇷',
  text: 'Antes tardaba 2 horas armando una clase. Ahora son 5 minutos. Mis domingos son míos otra vez.'
}, {
  initials: 'VP',
  name: 'Valeria P.',
  city: 'Mendoza 🇦🇷',
  text: 'El Bonus de Fichas de Seguimiento cambió mis reuniones con padres. Ahora llego con datos reales y nadie cuestiona mi metodología.'
}, {
  initials: 'MA',
  name: 'Micaela A.',
  city: 'Santa Fe 🇦🇷',
  text: 'El Elite 2 me salvó en noviembre. Armé la coreografía de muestra en 3 semanas sin un solo grito. Los padres lloraron de emoción.'
}, {
  initials: 'CR',
  name: 'Carolina R.',
  city: 'Tucumán 🇦🇷',
  text: 'El Mapa de Ruta cambió mi año. Sé exactamente qué dar cada semana. No existe la improvisación en mi salón desde que lo compré.'
}];
export function SocialProofSection() {
  return <section className="py-20 bg-cream-50/50" data-id="element-266">
      <div className="max-w-6xl mx-auto px-4" data-id="element-267">
        {/* Testimonials */}
        <div className="text-center mb-16" data-id="element-268">
          <h2 className="font-serif text-4xl font-bold text-gray-900 mb-4" data-id="element-269">
            Lo que dicen las profesoras
          </h2>
          <div className="flex items-center justify-center gap-2 text-xl font-bold text-gray-800" data-id="element-270">
            4.9/5 <Star className="w-6 h-6 text-gold-400 fill-gold-400" data-id="element-271" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-24" data-id="element-272">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-200" data-id="element-273">
              <div className="flex items-center gap-4 mb-4" data-id="element-274">
                <div className="w-12 h-12 bg-wine-100 rounded-full flex items-center justify-center font-bold text-wine-800" data-id="element-275">
                  {t.initials}
                </div>
                <div data-id="element-276">
                  <p className="font-bold text-gray-900" data-id="element-277">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-278">{t.city}</p>
                </div>
              </div>
              <div className="flex gap-1 mb-3" data-id="element-279">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold-400 fill-gold-400" data-id="element-280" />)}
              </div>
              <p className="text-gray-700 leading-relaxed italic" data-id="element-281">"{t.text}"</p>
            </div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 border-cream-200 text-center relative overflow-hidden" data-id="element-282">
          <div className="absolute top-0 right-0 w-32 h-32 bg-cream-50 rounded-bl-full -z-10" data-id="element-283"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-wine-50 rounded-tr-full -z-10" data-id="element-284"></div>

          <ShieldCheck className="w-16 h-16 text-gold-500 mx-auto mb-6" data-id="element-285" />
          <h3 className="font-serif text-3xl font-bold text-gray-900 mb-6" data-id="element-286">
            🛡️ Garantía 7 días sin preguntas
          </h3>
          <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-287">
            Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Elite en tu
            clase. Si no es lo que esperabas → 100% de devolución. Sin
            preguntas. Sin formularios. Sin drama.
          </p>
          <div className="inline-block bg-cream-100 text-wine-900 font-bold px-6 py-2 rounded-full text-sm tracking-wide" data-id="element-288">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </div>
      </div>
    </section>;
}